import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function product({ images }) {
    const settings = {
        items: 1,
        dots: true,
        loop: true,
        // autoplay: true,
        autoplayTimeout: 2500,
        autoplayHoverPause: true,
        margin: 30,
    };

    if (!images || images.length === 0) {
        console.error("No images provided to the Product component");
        return null;
    }
    return (
        <div className="sitem">
            <div className="img_box">
                <OwlCarousel className="owl-theme" {...settings} margin={10} nav>
                    {images.map((src, index) => (
                        <div className="item" key={index}>
                            <img src={src} alt={`Product image ${index + 1}`} />
                        </div>
                    ))}
                </OwlCarousel>
                <div className="img_detail">
                    <div className="left">
                        <span className="badge text-bg-success fw-normal">Sale</span>
                    </div>
                    <div className="rigt d-flex flex-column">
                        <a href='/categories' title='Quick View' className="view"><svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><g fill="none" stroke="currentColor"><circle cx="12" cy="12" r="3.5" /><path d="M20.188 10.934c.388.472.582.707.582 1.066c0 .359-.194.594-.582 1.066C18.768 14.79 15.636 18 12 18c-3.636 0-6.768-3.21-8.188-4.934c-.388-.472-.582-.707-.582-1.066c0-.359.194-.594.582-1.066C5.232 9.21 8.364 6 12 6c3.636 0 6.768 3.21 8.188 4.934Z" /></g></svg></a>
                        <a href='/categories' title='Wishlist' className="wishlist mt-2"><svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 512 512"><path fill="currentColor" d="M453.122 79.012a128 128 0 0 0-181.087.068l-15.511 15.7l-15.382-15.666l-.1-.1a128 128 0 0 0-181.02 0l-6.91 6.91a128 128 0 0 0 0 181.019l182.373 182.371l20.595 21.578l.491-.492l.533.533l19.296-20.359L460.032 266.94a128.147 128.147 0 0 0 0-181.019ZM437.4 244.313L256.571 425.146L75.738 244.313a96 96 0 0 1 0-135.764l6.911-6.91a96 96 0 0 1 135.713-.051l38.093 38.787l38.274-38.736a96 96 0 0 1 135.765 0l6.91 6.909a96.11 96.11 0 0 1-.004 135.765" /></svg></a>
                    </div>
                </div>
            </div>
            <div className="item_cont py-3">
                <p className="desc">Adidas Sport Shoes.</p>
                <a href='/categories' className="title">Adidas Sport shoes koi aesa wesa shoes nhi hai bhai kabhi halke mein le rha ho?</a>
            </div>
            <div className="price_div">
                <span className="last_price">₹15000</span>
                <span className='mx-2 fs_12 text-muted'>from</span>
                <span className="price">₹10000</span>
            </div>
            <div className="product_btn mt-3">
                {/* <button className="primary_btn fs_12 fw_500 w-100 mb-3">
                    <svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path fill="#fff" d="M19.5 22a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-10 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3" /><path d="M5 4h17l-2 11H7zm0 0c-.167-.667-1-2-3-2m18 13H5.23c-1.784 0-2.73.781-2.73 2s.946 2 2.73 2H19.5" /></g></svg>
                    Add to Cart</button> */}
                <a href='/categories' className="default_btn fs_12 fw_500 w-100">
                    <svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1.7em" height="1.7em" viewBox="0 0 32 32"><path fill="#fff" d="M4 7a1 1 0 0 0 0 2h2.22l2.624 10.5c.223.89 1.02 1.5 1.937 1.5h12.47c.903 0 1.67-.6 1.907-1.47L27.75 10h-2.094l-2.406 9H10.78L8.157 8.5A1.984 1.984 0 0 0 6.22 7zm18 14c-1.645 0-3 1.355-3 3s1.355 3 3 3s3-1.355 3-3s-1.355-3-3-3m-9 0c-1.645 0-3 1.355-3 3s1.355 3 3 3s3-1.355 3-3s-1.355-3-3-3m3-14v5h-3l4 4l4-4h-3V7zm-3 16c.564 0 1 .436 1 1c0 .564-.436 1-1 1c-.564 0-1-.436-1-1c0-.564.436-1 1-1m9 0c.564 0 1 .436 1 1c0 .564-.436 1-1 1c-.564 0-1-.436-1-1c0-.564.436-1 1-1" /></svg>
                    Buy Now</a>
            </div>
        </div>
    )
}
